import { IS_LOADING_POST_HOME, GET_POST_HOME, IS_LOADING_POST_HOME_PROFESSIONAL, GET_POST_HOME_PROFESSIONAL, ADD_LIKE_POST_HOME, IS_LOADING_LIKE_POST_HOME, REMOVE_LIKE_POST_HOME, ADD_POST_HOME, IS_LOADING_ADD_POST_HOME, ERROR_ADD_POST_HOME, DELETE_POST, ADD_POST_HOME_CAMPAIGN } from '../actions/types'

const initialRegisterEmailState = {
    postHome: [],
    postHomeCampaign:null,
    page: 0,
    hasMore: true,
    isLoadingPostHome: true,
    postHomeProfessional: [],
    isLoadingPostHomeProfessional: true,
    isLoadingLikePostHome: false,
    isLoadingNewPost: false,
}

export default function (state = initialRegisterEmailState, action) { //lo que se manda de personasAction en el dispatch es el action
    switch (action.type) {
        case IS_LOADING_ADD_POST_HOME:
            return { ...state, isLoadingNewPost: true }

        case IS_LOADING_POST_HOME:
            return { ...state, isLoadingPostHome: true }
        case GET_POST_HOME:
            var ids = new Set(state.postHome.map(d => d._id));
            var merged = [...state.postHome,
            ...action.payload.data.filter(d => !ids.has(d._id))];
            return {
                ...state,
                hasMore: action.payload.hasMore,
                page: action.payload.page,
                postHome: merged,
                isLoadingPostHome: false
            }
        case IS_LOADING_POST_HOME_PROFESSIONAL:
            return { ...state, isLoadingPostHomeProfessional: true }
        case GET_POST_HOME_PROFESSIONAL:
            return { ...state, postHomeProfessional: action.payload, isLoadingPostHomeProfessional: false }
        case IS_LOADING_LIKE_POST_HOME:
            return { ...state, isLoadingLikePostHome: true }
        case ERROR_ADD_POST_HOME:
            return { ...state, isLoadingNewPost: false }
        case ADD_POST_HOME:
            const postHome = state.postHome

            if (action.payload.type === "postCampaing") {
                if (postHome[0].type !== "postCampaing") {
                    postHome.splice(0, 0, action.payload)
                }
            } else {
                postHome.splice(0, 0, action.payload)
            }

            return { ...state, postHome: [...postHome], isLoadingNewPost: false }
        case ADD_POST_HOME_CAMPAIGN:
            const postHomeCampaign = action.payload

           

            return { ...state, postHomeCampaign, isLoadingNewPost: false }
        case DELETE_POST:
            var deletePost = state.postHome.filter(post => post._id !== action.payload)

            return { ...state, postHome: deletePost, isLoadingProfile: false }
        case ADD_LIKE_POST_HOME:
            var currentPosts = state.postHome
            currentPosts.map((post) => {
                if (post._id === action.payload.contentID) {
                    post.reactions = action.payload.value
                }
            })
            return { ...state, postHome: currentPosts, isLoadingLikePostHome: false }
        case REMOVE_LIKE_POST_HOME:
            var currentPosts = state.postHome
            currentPosts.map((post) => {
                if (post._id === action.payload.contentID) {
                    post.likes -= action.payload.value
                    if (post.myReaction)
                        post.myReaction.value = 0
                }
            })
            return { ...state, postHome: currentPosts, isLoadingLikePostHome: false }
        default:
            return state

    }
}